<template>
  <div class="content extended-forms">
    <div class="row">
      <ArtistSelect
        class="col-md-12"
        @memberChangeEvent="getArtistInfo"
        :is-filter="true"
        :include-unit-artist="true"
        :initial-unit-id="$route.query.unitId ? parseInt($route.query.unitId, 10) : null"
        :initial-member-id="$route.query.artistId ? parseInt($route.query.artistId, 10) : null"
      />
    </div>
    <div class="row">
      <el-table :data="tags">
        <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
        <el-table-column :min-width="135" align="right" label="띄워주기">
          <div slot-scope="props">
            <base-button @click.native="showModal(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-pencil" />
            </base-button>
          </div> </el-table-column
        ><el-table-column :min-width="135" align="right" label="갤러리보기">
          <div slot-scope="props">
            <base-button @click.native="showTagCollections(props.row.tag)" class="edit btn-link" type="warning" size="sm" icon>
              <i class="tim-icons icon-zoom-split" />
            </base-button>
          </div>
        </el-table-column>
      </el-table>
    </div>
    <CollectionHashTagsModal
      :key="componentKey"
      :tagId="tagId"
      :artistId="memberId"
      :unitId="unitId"
      :shouldShow="collectionModal.show"
      :onConfirm="onCollectionModal"
      :onCancel="onCancelModal"
    ></CollectionHashTagsModal>
  </div>
</template>
<script>
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";
import { URLUtils } from "@/util/URLUtils";
import CollectionHashTagsModal from "./CollectionHashTagsModal.vue";

export default {
  components: {
    ArtistSelect,
    CollectionHashTagsModal,
  },
  async created() {},
  data() {
    return {
      unitId: null,
      memberId: null,
      tags: [],
      tableColumns: [
        {
          prop: "tag",
          label: "태그",
          minWidth: 150,
        },
        {
          prop: "tagCount",
          label: "태그수",
          minWidth: 150,
        },
      ],
      tagId: null,
      componentKey: null,
      collectionModal: {
        show: false,
      },
    };
  },
  watch: {},
  methods: {
    async getArtistInfo(param) {
      this.unitId = param.unitId;
      this.memberId = param.memberId;
      await this.getCollectionHashTags();
    },
    async getCollectionHashTags() {
      const queryParams = {
        unitId: this.unitId,
        artistId: this.memberId || undefined,
      };

      const params = { unitId: this.unitId, artistId: this.memberId };

      const path = `/collection/collectionHashTags?${URLUtils.objectToQueryString(queryParams)}`;
      if (this.$route.fullPath !== path) {
        try {
          await this.$router.push(path);
        } catch (ex) {}
      }
      return this.$axios
        .get(`/collection/collectionHashTags`, {
          params,
        })
        .then((res) => {
          this.tags = res.data.data.data;
        });
    },
    showTagCollections(tag) {
      this.$router.push(`/collection/collections?unitId=${this.unitId}&state=1&gubun=2&searchWord=${tag}&searchType=1&withParams=detail`);
    },
    showModal(tag) {
      this.tagId = tag;
      this.collectionModal.show = true;
    },
    onCollectionModal() {},
    onCancelModal() {
      this.collectionModal.show = false;
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  .row {
    margin-bottom: 20px;
  }
}
</style>
